<template>
    <v-table class="bordered text-left" density="compact" v-if="groupe?.token">

        <tbody>
            <tr>
                <td class="font-weight-medium">Groupe</td>
                <td>{{ groupe?.default_fields?.club || '-' }}</td>
            </tr>
            <tr>
                <td class="font-weight-medium">Code</td>
                <td>{{ groupe?.token }}</td>
            </tr>
            <tr>
                <td class="font-weight-medium">Date d'expiration</td>
                <td>{{ formatDateExpiration(groupe?.date_expiration) }}</td>
            </tr>
            <tr>
                <td class="font-weight-medium">Accès avant ouverture</td>
                <td>{{ groupe?.allow_before_opening ? 'Oui' : 'Non' }}</td>
            </tr>
            <tr>
                <td class="font-weight-medium">Limite d'inscriptions</td>
                <td>{{ groupe?.nb_inscrits }} / {{ groupe?.max_inscrits === 0 ? 'Illimitée' : groupe?.max_inscrits }}
                </td>
            </tr>
            <tr>
                <td class="font-weight-medium">Parcours payants à l'inscription</td>
                <td>{{ groupe?.doit_payer ? 'Oui' : 'Non' }}</td>
            </tr>
            <tr>
                <td class="font-weight-medium">Vous pouvez vous inscrire aux parcours complets</td>
                <td>{{ groupe?.inscription_course_complete ? 'Oui' : 'Non' }}</td>
            </tr>
            <tr>
                <td class="font-weight-medium">Parcours restreints</td>
                <td>{{ limitation_parcours(groupe.limit_acces_parcours, groupe.filter_parcours) }}
                </td>
            </tr>
            <tr>
                <td class="font-weight-medium">Options payantes à l'inscription</td>
                <td>{{ groupe?.doit_payer_options ? 'Oui' : 'Non' }}</td>
            </tr>
            <tr>
                <td class="font-weight-medium">Vous pouvez vous inscrire aux options complètes</td>
                <td>{{ groupe?.inscriptions_options_completes ? 'Oui' : 'Non' }}</td>
            </tr>



        </tbody>
    </v-table>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    props: {
        groupe: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        limitation_parcours(limit_acces_parcours, filter_parcours) {
            if (limit_acces_parcours) {
                return 'Limité à : ' + filter_parcours.split(',').map(id => id.trim()).map(id => this.mainStore.module.courses.list.find(c => c.id == id)?.nom).join(', ');
            }
            return 'Non (tous les parcours)';
        },
        formatDateExpiration(date) {
            if (!date || date === '0000-00-00') return 'Non définie';
            return this.$moment ? this.$moment(date).format('DD/MM/YYYY') : date;
        },

    },

};
</script>

<style lang="scss" scoped></style>
